export function porcentagem(valor) {
  if (valor > 0) {
    return "%";
  }
}
